import React from 'react';
import { Modal, Form, Button, Upload } from 'antd';
import JsonView from '@/components/json-view';
import { ROW_KEY } from '../';

class FileDetails extends React.Component {
  state = {
    isSaveDisabled: true,
  };

  onValuesChange = (values = {}) => {
    this.values = {
      file:
        values.file && values.file.length > 0
          ? values.file.map((item) => item.originFileObj)
          : values.file,
    };

    this.setState({
      isSaveDisabled: !(this.values.file && this.values.file.length > 0),
    });
  };

  render() {
    const {
      file: { fileName, path },
      onCancel,
      dispatch,
    } = this.props;
    const { isSaveDisabled } = this.state;
    const isView = this.props.file[ROW_KEY];

    return (
      <Modal
        open
        width={1000}
        title={`${isView ? 'View' : 'New'} Swagger File`}
        closable={false}
        onCancel={onCancel}
        footer={
          <>
            <Button
              type="text"
              onClick={onCancel}
            >
              Cancel
            </Button>
            {!isView && (
              <Button
                type="primary"
                disabled={isSaveDisabled}
                onClick={() => {
                  dispatch({
                    type: 'swaggerFileModel/postFiles',
                    payload: this.values,
                    callback: onCancel,
                  });
                }}
              >
                Save
              </Button>
            )}
          </>
        }
      >
        {isView ? (
          <JsonView filePath={`${path}/${fileName}`} />
        ) : (
          <Form
            layout="vertical"
            onValuesChange={(_, values) => this.onValuesChange(values)}
          >
            <Form.Item
              name="file"
              label="Upload Swagger File"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) {
                  return e;
                }
                return e && e.fileList;
              }}
            >
              <Upload
                maxCount={1}
                customRequest={({ onSuccess }) => onSuccess()}
              >
                <Button>Choose File</Button>
              </Upload>
            </Form.Item>
          </Form>
        )}
      </Modal>
    );
  }
}

export default FileDetails;
